<template>
  <div class="flex items-center">
    <button
      :type="type"
      :disabled="disabled"
      class="w-full inline-flex justify-center items-center border text-sm font-medium rounded-md sm:ml-3 sm:w-auto sm:text-sm"
      :class="{
        'px-4 py-2': buttonSize === 'normal',
        'px-4 py-1.5': buttonSize === 'small',
        'cursor-not-allowed border-gray-200 text-white bg-gray-200': disabled,
        'focus:outline-none focus:ring-2 focus:ring-offset-2': !disabled,
        'bg-indigo-600 hover:bg-indigo-700 text-white focus:ring-indigo-500 shadow-sm': !disabled && buttonStyle === 'primary',
        'text-gray-700 bg-white hover:bg-gray-50 focus:ring-indigo-500 border-gray-300 shadow-sm': !disabled && buttonStyle === 'secondary',
        'text-indigo-600 hover:text-indigo-500': !disabled && buttonStyle === 'clear',
        'text-gray-700 bg-gray-100 hover:bg-gray-100 focus:ring-indigo-500 border-gray-200 shadow-sm': !disabled && buttonStyle === 'gray',
        'bg-red-600 hover:bg-red-700 text-white focus:ring-red-500 shadow-sm': !disabled && buttonStyle === 'red',
      }"
      @click="handleClick"
    >
      <slot />
    </button>
    <svg
      v-if="loading"
      class="animate-spin ml-3 h-5 w-5 text-spark-purple"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        class="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="4"
      />
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: null,
    },
    buttonStyle: {
      type: String,
      default: 'primary',
    },
    buttonSize: {
      type: String,
      default: 'normal',
    },
  },
  emits: ['click'],
  methods: {
    handleClick(evt) {
      this.$emit('click', evt);
    },
  },
};
</script>
